import camelcaseKeys from "camelcase-keys";
import { IDomainPagination } from "../../domain/pagination";
import { IDomainApiPagination } from "../../domain/api-pagination";

export const apiPaginationTransformer = (
  meta: IDomainApiPagination
): IDomainPagination => {
  return camelcaseKeys(meta);
};
